var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-input"},[(!!_vm.label)?_c('div',{staticClass:"input-label"},[_vm._v(_vm._s(_vm.label)+"：")]):_vm._e(),_c('div',{staticClass:"form-input"},[_c('input',{attrs:{"type":"text","readOnly":_vm.readonly,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onInput}}),_vm._t("right-icon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }